import api from 'services/api';

export const getSearchData = async () =>
  api.get('https://run.mocky.io/v3/1adb5d21-981a-4beb-b842-6ad788320391');
